export class Address {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  street: string;
  streetNumber: string;
  city: string;
  zipCode: string
  country: string;
  note: string;
}
